/**
 * Created by akrio on 2018/3/23.
 */
import { BULK_DEFAULT_INFO } from "../mutation-types";

export default {
  state: {
    defaultInfo: [],
  },
  mutations: {
    [BULK_DEFAULT_INFO](state, defaultInfo) {
      state.defaultInfo = defaultInfo;
    },
  },
  getters: {
    [BULK_DEFAULT_INFO](state) {
      return state.defaultInfo;
    },
  },
};
